import React from "react";

interface ModelLoadErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  onError?: (error: Error) => void;
}

interface ModelLoadErrorBoundaryState {
  hasError: boolean;
}

export class ModelLoadErrorBoundary extends React.Component<
  ModelLoadErrorBoundaryProps,
  ModelLoadErrorBoundaryState
> {
  state: ModelLoadErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): ModelLoadErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    this.props.onError?.(error);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }

    return this.props.children;
  }
}
